<template>
  <a-modal
    title="添加人员"
    :visible="showTubeView"
    :width="700"
    destroyOnClose
    @ok="handleOk"
    @cancel="closeTubeView"
  >
    <a-row :gutter="48">
      <a-col :md="24" :sm="24">
        <a-transfer
          :list-style="{
      width: '300px',
      height: '300px',
    }"
          :titles="titles"
          :data-source="userlist"
          show-search
          :filter-option="filterOption"
          :target-keys="targetKeys"
          :render="item => item.title"
          @change="handleChange"
          @search="handleSearch"
        />
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import moment from 'moment'
import { Transfer } from 'ant-design-vue'
export default {
  data() {
    return {
      showTubeView: false,
      userlist: [], //
      targetKeys: [],
      titles: ['人员列表', '已选择人员']
    }
  },

  computed: {
    rules() {
      return {}
    }
  },
  mounted() {},
  created() {
    this.getUserList()
  },
  methods: {
    moment,
    getUserList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        
        let list = []
        data.map(item => {
          list.push({
            title: item.realName,
            key: item.id
          })
        })
        this.userlist = list
      })
    },
    edit(list) {
      console.log(list)
      this.$nextTick(() => {
        this.targetKeys = list || []
        this.showTubeView = true
      })
    },
    handleOk() {
      if (this.targetKeys.length > 0) {
        let list = []
        for (let i = 0; i < this.targetKeys.length; i++) {
          list.push(this.userlist.find(item => item.key == this.targetKeys[i]))
        }
        this.$emit('addPepople', list)
      }
      this.closeTubeView()
    },
    closeTubeView() {
      this.showTubeView = false
      this.targetKeys = []
    },
    filterOption(inputValue, option) {
      return option.title.indexOf(inputValue) > -1
    },
    handleChange(targetKeys, direction, moveKeys) {
      this.targetKeys = targetKeys
    },
    handleSearch(dir, value) {
      console.log('search:', dir, value)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
